import { Modbus } from "coolremote-sdk";
import { Thunk, thunk } from "easy-peasy";

export interface IModbusTemplatesModel {
  getAllModbusTemplates: Thunk<IModbusTemplatesModel, { type?: string; search?: string } | undefined>;
  getModbusTemplateById: Thunk<IModbusTemplatesModel, string>;
  createModbusTemplate: Thunk<IModbusTemplatesModel, any>;
  updateModbusTemplate: Thunk<IModbusTemplatesModel, { id: string; data: any }>;
  deleteModbusTemplate: Thunk<IModbusTemplatesModel, string>;
}

export const modbusTemplatesModel: IModbusTemplatesModel = {
  getAllModbusTemplates: thunk(async (actions, payload) => {
    return Modbus.getAdminModbusLibraryTemplates(payload);
  }),
  getModbusTemplateById: thunk(async (actions, payload) => {
    return Modbus.getAdminModbusLibraryTemplateById(payload);
  }),
  createModbusTemplate: thunk(async (actions, payload) => {
    return Modbus.createAdminModbusLibraryTemplate(payload);
  }),
  updateModbusTemplate: thunk(async (actions, payload) => {
    return Modbus.updateAdminModbusLibraryTemplate(payload.id, payload.data);
  }),
  deleteModbusTemplate: thunk(async (actions, payload) => {
    return Modbus.deleteAdminModbusLibraryTemplate(payload);
  }),
};
